/* eslint-disable */
// @ts-nocheck
import React from "react";
import { TabList, Tab } from "@carbon/react";
import Badge from "../../components/badge/Badge";
import { SIDEPANEL_GENERAL_TRANSLATIONS } from "../../translations/util";

interface IProps {
  numOfComments?: number;
  addAlarmComment?: any;
}

export default ({ numOfComments, addAlarmComment }: IProps) => {
  return (
    <>
      {numOfComments || addAlarmComment ? (
        <TabList ariaLabel="Extra Info" className="extra-tabs">
          <Tab
            data-cy={`${SIDEPANEL_GENERAL_TRANSLATIONS.alarmsTabs.comments.replaceAll(
              " ",
              ""
            )}-tab`}
          >
            {SIDEPANEL_GENERAL_TRANSLATIONS.alarmsTabs.comments}{" "}
            <Badge
              badgeCounter={
                numOfComments ? (numOfComments > 99 ? "99+" : numOfComments) : 0
              }
            />
          </Tab>
          <Tab>{SIDEPANEL_GENERAL_TRANSLATIONS.alarmsTabs.additionalInfo}</Tab>
        </TabList>
      ) : (
        <TabList ariaLabel="Extra Info" className="extra-tabs">
          <Tab>{SIDEPANEL_GENERAL_TRANSLATIONS.alarmsTabs.additionalInfo}</Tab>
        </TabList>
      )}
    </>
  );
};
